export default __webpack_public_path__ + "static/media/KZ.Т.12.2498.e55d1d01.svg";